/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface AccessProjectsInvitationsResendCreate$Params {
  iid: number;
  project_id: number;
}

export function accessProjectsInvitationsResendCreate(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsInvitationsResendCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsInvitationsResendCreate.PATH, 'post');
  if (params) {
    rb.path('iid', params.iid, {});
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

accessProjectsInvitationsResendCreate.PATH = '/api/access/projects/{project_id}/invitations/{iid}/resend/';
